const state = {
  logs: [],
  downloadMessage: ""
};
const mutations = {
  SET_LOGS(state, logs) {
    state.logs = logs

  },
  SET_DOWNLOAD_MESSAGE(state, downloadMessage) {
    state.downloadMessage = downloadMessage;
  }
};
const getters = {
  getLogs: (state) => {
    return state.logs
  },
};

export default {
  state,
  mutations,
  getters,
};